import type { CaseStatus } from "../api/types.ts"

/**
 * 인보이스(COMMERCIAL INVOICE)를 뽑을 수 있는가.
 *
 * **`server/src/domain/case-invoice.ts` 를 옮겨 적은 사본이다. 한쪽을 고치면 다른 쪽도 고친다.**
 * 화면이 먼저 걸러 주지만 판정은 서버가 다시 한다 — 여기만 고쳐서 뚫리지 않는다
 * (비밀번호 규칙을 두는 방식과 같다).
 *
 * 서류가 확정된 뒤부터다. 입고 단계까지는 쿨트랙JP가 품목을 계속 고칠 수 있어 뽑을 때마다
 * 내용이 달라지고, 확정 뒤에는 품목이 잠겨 언제 뽑아도 같은 서류가 나온다.
 * 출고·반송완료에서도 켜 둔다 — 그 서류를 실제로 쓰는 때가 출고 뒤다.
 */
const PRINTABLE_STATUSES: readonly CaseStatus[] = ["documented", "shipped", "returned"]

export type InvoicePrintCheck = { ok: true } | { ok: false; code: string }

export function canPrintInvoice(input: {
  status: CaseStatus
  itemCount: number
}): InvoicePrintCheck {
  if (!PRINTABLE_STATUSES.includes(input.status)) {
    return { ok: false, code: "CASE_NOT_DOCUMENTED" }
  }
  if (input.itemCount === 0) return { ok: false, code: "NO_INVOICE_ITEMS" }
  return { ok: true }
}
